import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconWalmart = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <g clipPath={`url(#&{svgId})`}>
          <circle
            cx="10"
            cy="10"
            r="8"
            fill="#1D7AD9"
          />
          <path
            d="M9.99661 4.6665C9.59814 4.6665 9.28221 4.89365 9.28221 5.16938L9.52464 7.95946C9.55043 8.12753 9.75289 8.25751 9.9979 8.25751C10.2429 8.25751 10.4441 8.12621 10.4712 7.95946L10.7149 5.16938C10.7149 4.89365 10.3964 4.66782 9.9979 4.66782L9.99661 4.6665ZM6.05324 6.89857C5.92795 6.91538 5.80861 6.96319 5.70565 7.0378C5.6027 7.11242 5.51926 7.21158 5.46263 7.32661C5.26276 7.67849 5.29757 8.07107 5.53098 8.20893L8.02492 9.39061C8.18095 9.4497 8.39244 9.33678 8.51494 9.12802C8.64389 8.91138 8.62842 8.66847 8.49947 8.56081L6.24667 6.95372C6.18779 6.91976 6.12087 6.90296 6.05324 6.90514V6.89857ZM13.9413 6.89857C13.8736 6.89639 13.8067 6.9132 13.7478 6.94715L11.495 8.56212C11.3661 8.66979 11.3571 8.91269 11.4796 9.12933C11.6021 9.34466 11.8135 9.45758 11.9696 9.39193L14.4635 8.21024C14.6995 8.07238 14.733 7.68505 14.5344 7.32792C14.4767 7.2132 14.3922 7.11465 14.2883 7.04094C14.1844 6.96723 14.0644 6.9206 13.9387 6.90514L13.9413 6.89857ZM8.11906 10.5749C8.08736 10.5734 8.05571 10.5788 8.02621 10.5907L5.53227 11.7802C5.29757 11.9194 5.26276 12.3054 5.46263 12.6639C5.66251 13.0223 6.01326 13.1812 6.24667 13.0433L8.49947 11.4389C8.62842 11.3299 8.63874 11.087 8.51623 10.8717C8.47867 10.7942 8.42264 10.7275 8.35326 10.6777C8.28388 10.628 8.20336 10.5967 8.11906 10.5867V10.5749ZM11.8767 10.5749C11.7924 10.5849 11.7119 10.6161 11.6425 10.6659C11.5732 10.7157 11.5171 10.7824 11.4796 10.8598C11.3506 11.0752 11.3674 11.3181 11.4963 11.427L13.7491 13.046C13.9825 13.1773 14.3333 13.0171 14.5344 12.6665C14.7356 12.3159 14.6995 11.922 14.4635 11.7829L11.9696 10.5986C11.9401 10.5868 11.9084 10.5814 11.8767 10.5828V10.5749ZM9.99661 11.7435C9.75289 11.7435 9.55043 11.8748 9.52464 12.0402L9.28221 14.8303C9.28221 15.106 9.59943 15.3332 9.9979 15.3332C10.3964 15.3332 10.7149 15.106 10.7149 14.8303L10.4712 12.0428C10.4441 11.8748 10.2429 11.7461 9.9979 11.7461L9.99661 11.7435Z"
            fill="#FFC220"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="16"
              height="16"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
